import ProfitMargins from './ProfitMargins'

export default ProfitMargins
